import styled from 'styled-components';

const NavigationText = styled.span`
  font-family: 'Avenir Light', 'Arial', sans-serif;
  font-size: 15px;
  color: #999;
  font-weight: 400;
  display: inline;
  margin-right: 5px;
  height: 20px;
  line-height: 20px;
`;

export default NavigationText;
